import React from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../useAuth";

const ErrorMessage = () => {
    const navigate = useNavigate();
    const { errorMessage } = useAuth();

    return (
        <div className="flex flex-column align-items-center justify-content-center p-4" style={{ minHeight: '40vh' }}>
            <div className="mb-4 text-center">
                <i className="pi pi-exclamation-triangle text-4xl text-orange-500 mb-3" />
                <h2 className="mb-2">Something went wrong</h2>
                <p className="mb-4 text-lg">{errorMessage}</p>
            </div>
            <Button
                label="Back to Login"
                icon="pi pi-arrow-left"
                className="p-button-primary"
                onClick={() => navigate("/")}
            />
        </div>
    );
};

export default ErrorMessage; 